/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

export { velocityPerSecond };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/velocity.es.js
// module id = /55F
// module chunks = 0